// In app/javascript/custom/carousel_helper.js

function addOrRemoveSpace() {
  const placeElements = document.querySelectorAll('.place');
  if (window.innerWidth > 1199 || window.innerWidth < 768) {
    placeElements.forEach(el => el.style.marginBottom = '15px');
  } else {
    placeElements.forEach(el => el.style.marginBottom = '0');
  }
}

function carouselNormalization() {
  const items = document.querySelectorAll('#mainCarousel .carousel-item');
  if (!items.length) return;

  function normalizeHeights() {
    let maxHeight = 0;
    // Reset heights before recalculating
    items.forEach(item => item.style.minHeight = 'auto');
    // Find the max height
    items.forEach(item => {
      if (item.offsetHeight > maxHeight) {
        maxHeight = item.offsetHeight;
      }
    });
    // Apply the max height to all items
    if (maxHeight > 0) {
      items.forEach(item => item.style.minHeight = `${maxHeight}px`);
    }
  }

  normalizeHeights();
  window.addEventListener('resize', () => {
    addOrRemoveSpace();
    normalizeHeights();
  });
}

// Wait for the full page (including images) to load before running scripts
window.addEventListener("load", () => {
  addOrRemoveSpace();
  carouselNormalization();
});